import React from 'react';
import { useIsMobile } from '../../hooks';
import { Icon } from '../Icon';

import './styles.scss';

export interface BreadcrumbLink {
    text: string;
    url: string;
}

interface Props {
    links: BreadcrumbLink[];
    current: string;
    title: string;
    backLinkText?: string;
    onBackClick?: () => void;
}

export const HeaderWithBreadcrumbs = ({ title, links, current, backLinkText, onBackClick }: Props) => {
    const isMobile = useIsMobile();

    const backClickHandler = () => {
        if (onBackClick) {
            onBackClick();
        }
    };

    return (
        <div className='app-page-header-with-breadcrumbs'>
            {!isMobile && (
                <div className='app-breadcrumbs'>
                    <div className='razem-app__wrapper app-breadcrumbs__wrapper'>
                        {links.map((l) => (
                            <React.Fragment key={l.url}>
                                <a href={l.url} key={l.url} className='app-breadcrumbs__link'>
                                    {l.text}
                                </a>
                                <Icon icon='chevron-right' color='white' size='12' className='app-breadcrumbs__icon' />
                            </React.Fragment>
                        ))}
                        <span className='app-breadcrumbs__link'>{current}</span>
                    </div>
                </div>
            )}

            <div className='razem-app__wrapper app-page-header-with-breadcrumbs__wrapper'>
                {onBackClick ? (
                    <button
                        onClick={backClickHandler}
                        className={`app-page-header__back-button ${
                            backLinkText ? 'app-page-header__back-button--position-regular' : ''
                        }`}
                    >
                        <Icon icon='chevron-left' color='white' size='20' />
                        {backLinkText ? <span className='app-page-header__backlink-text'>{backLinkText}</span> : ''}
                    </button>
                ) : (
                    <h1 className='app-page-header-with-breadcrumbs__title'>{title}</h1>
                )}
            </div>
        </div>
    );
};
